<template>
  <v-img height="200px" :aspect-ratio="aspectRatio" :src="url ? url : 'img/icon.png'">
    <slot></slot>
  </v-img>
</template>

<script>
import EventBus from '../../events/EventBus';
import { Logger } from '@aws-amplify/core';
import Storage from '@aws-amplify/storage';

export default {
  name: 'IpWayS3Image',
  props: ['url', 'aspectRatio', 'maxHeight'],
  data() {
    return {
      error: '',
      logger: {}
    };
  },
  computed: {
  },
  mounted() {
    this.logger = new Logger(this.$options.name);
  },
  methods: {
    setError: function(e) {
      this.error = e.message || e;
      this.logger.error(this.error);
    }
  }
};
</script>
